module.exports = __webpack_public_path__ + "static/img/case_img03.4575fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/case_img03.png
// module id = jxGh
// module chunks = 1